export default "__VITE_ASSET__CfWmcNau__"